module.exports = __webpack_public_path__ + "img/eye.9eff15c3.svg";